import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-expense',
  templateUrl: './icon-expense.component.html',
  styles: []
})
export class IconExpenseComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
